import React from "react";
import Col from '../../common/Col';
import Row from '../../common/Row';
import PropTypes from "prop-types";

const Legende = (props) => {
    const style = {
        zIndex: '1000',
        position: 'absolute',
        top: '10px',
        right: '10px',
        backgroundColor: 'white',
        padding: '12px',
        width: '300px',
        boxShadow: '-4px 4px 18px #4d4a4a',
        borderRadius: '5px'
    };

    return (<div style={{ position: 'relative' }} onMouseOut={props.onMouseOut}>
        <div style={style}>
            <Col size={12}>
                {props.customRows}
            </Col>
        </div>
        <div className="background"/>
    </div>);
};

Legende.propTypes = {
    onMouseOut: PropTypes.func,
    customRows: PropTypes.array
};

export default Legende;